import { DateTime } from "luxon";

export function isSameDay(a: DateTime, b: DateTime): boolean {
  const dayAInUTC = a.setZone("UTC");
  const dayBInUTC = b.setZone("UTC");

  return dayAInUTC.toFormat("yyyy-MM-dd") === dayBInUTC.toFormat("yyyy-MM-dd");
}
